import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { adviserEdit, adviserUpdate, officeAllList, adviserAllList, adviserBlacklist } from '../../../../store/actions/memberActions'
import { Modal, Switch, Input, message, Select, Upload, Tooltip, Collapse, InputNumber } from 'antd';
import { listAllEvents } from '../../../../store/actions/achievementActions';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
const { TextArea } = Input;

const QualificationInput = ({ uploadButton, getBase64, generateUrl, beforeUpload, onUpdate, value }) => {

  const [image, setImage] = useState()

  const [imageUrl, setImageUrl] = useState()
  const [title, setTitle] = useState()

  useEffect(() => {
    if (title) {
      onUpdate({ ...value, title })
    }
  }, [title])

  useEffect(() => {
    if (imageUrl) {
      onUpdate({ ...value, imageUrl })
    }
  }, [imageUrl])

  useEffect(() => {
    onUpdate({ ...value, image })
  }, [image])

  useEffect(() => {
    if (value?.image) {
      setImage(value.image)
    }
    setTitle(value?.title ? value.title : "")
  }, [value])

  useEffect(() => {
    setImageUrl(value.imageUrl)
    setImage(value.imageUrl)
    setTitle(value.title)
  }, [])

  const handleChangeImage = (info) => {
    setImageUrl(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl => {
      setImage(imageUrl)
    },
      // setloading(false)
    );
  };


  return (
    <div className="form-group d-flex flex-column">

      <div className='align-self-center'>
        <Tooltip
          title={image ?
            <a href={generateUrl(image)} target="_blank">
              <img src={image?.startsWith("data:application/pdf") || image?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : image} alt="preview" style={{ width: 200 }} />
            </a> :
            null}
          placement="top"
        >
          <Upload
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={handleChangeImage}
            style={{ width: "100%" }}
          >
            {image ?
              <img src={image?.startsWith("data:application/pdf") || image?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : image} alt="avatar" style={{ width: '90%' }} />
              :
              uploadButton
            }
          </Upload>
        </Tooltip>
      </div>

      <input type="text"
        className='form-control form-control-sm'
        placeholder='Qualification name'
        onChange={(e) => setTitle(e.target.value)}
        value={title}
      />
    </div>
  )
}

const AchievementInput = ({ onUpdate, value }) => {
  const [event, setEvent] = useState()
  const [category, setCategory] = useState()
  const [rank, setRank] = useState()
  const isSyncingFromValue = useRef(false);

  const [categoriesByEvent, setCategoriesByEvent] = useState();

  const { achievementEventList } = useSelector((state) => state.achievementEvent);

  const dispatch = useDispatch()

  useEffect(() => {
    isSyncingFromValue.current = true;

    if (value?.event) { setEvent(parseInt(value?.event)) }
    if (value?.category) { setCategory(parseInt(value?.category)) }
    if (value?.rank) { setRank(parseInt(value?.rank)) }
  }, [value])


  useEffect(() => {
    dispatch(listAllEvents());
  }, [dispatch]);

  useEffect(() => {
    axios.get(`achievements/getCategoriesByEvent/${event}`).then(({ data }) => {
      setCategoriesByEvent(data.data)
    })
    onUpdate({ ...value, event })
    if (isSyncingFromValue.current) {
      isSyncingFromValue.current = false; // reset for future updates
      return;
    }
  }, [event])

  useEffect(() => {
    onUpdate({ ...value, category })
    if (isSyncingFromValue.current) {
      isSyncingFromValue.current = false; // reset for future updates
      return;
    }

  }, [category])

  useEffect(() => {
    if (isSyncingFromValue.current) {
      isSyncingFromValue.current = false; // reset for future updates
      onUpdate({ ...value, rank })
      return;
    }

  }, [rank])

  function handleEventChange(e) {
    setEvent(e)
    axios.get(`achievements/getCategoriesByEvent/${e}`).then(({ data }) => {
      setCategoriesByEvent(data.data)
    })
  }

  return (
    <div>
      <div>
        <label className='text-secondary'>Event</label>
        <Select
          onChange={handleEventChange}
          style={{ width: '100%' }}
          value={event}
          options={
            achievementEventList?.map((item) => ({
              value: item.id,
              label: item.name
            }))
          }
        >
        </Select>
      </div>

      {categoriesByEvent?.length > 0 && (
        <div className='mt-2'>
          <label className='text-secondary'>Category</label>
          <Select
            style={{ width: '100%' }}
            onChange={(e) => { setCategory(e) }}
            value={category}
            options={
              categoriesByEvent?.map((item) => ({
                value: item.id,
                label: item.name
              }))
            }
          >
          </Select>
        </div>
      )}

      {category && (
        <div className='w-100 d-flex justify-content-center mt-2'>
          <label className='text-secondary mr-3'>Rank</label>
          <InputNumber
            min={1}
            value={rank}
            onChange={(value) => setRank(value)}
            formatter={(value) => `#${value}`}
            parser={(value) => value.replace('#', '')}
          />
        </div>
      )}
    </div>
  )
}

const AdviserEdit = () => {
  const dataadviserEdit = useSelector(state => state.adviserEdit)
  const { adviser } = dataadviserEdit

  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [office, setoffice] = useState('')
  const [phone, setphone] = useState('')
  const [gender, setgender] = useState('')
  const [joindate, setjoindate] = useState('')
  const [status, setstatus] = useState('')
  const [isnpwp, setisnpwp] = useState('')
  const [issalary, setissalary] = useState('')
  const [haired, sethaired] = useState('')
  const [nik, setNik] = useState('')
  const [verified, setVerified] = useState(adviser?.is_verified)

  const [showModalBlacklist, setShowModalBlacklist] = useState(false);
  const [blacklistReason, setBlacklistReason] = useState('');

  const [nda, setNda] = useState();
  const [ndaFile, setNdaFile] = useState();

  const [mcquaig, setMcquaig] = useState();
  const [mcquaigFile, setMcquaigFile] = useState();

  const [pfindo, setPfindo] = useState();
  const [pfindoFile, setPfindoFile] = useState();

  const [ktp, setKtp] = useState();
  const [ktpFile, setKtpFile] = useState();

  const [achievements, setAchievements] = useState([]);
  const [qualification, setQualification] = useState([]);

  let dispatch = useDispatch()
  let history = useHistory()
  const id = localStorage.getItem('id_adviser');

  useEffect(() => {
    dispatch(adviserEdit(id))
    dispatch(officeAllList())
    dispatch(adviserAllList())
  }, [dispatch, id])

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
    if (!userInfo.permission.includes("adviser-edit")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const dataofficeAllList = useSelector(state => state.officeAllList)
  const listsOffice = dataofficeAllList.listsOffice.map((item) => { return { value: item.value, label: item.label } })

  const dataadviserAllList = useSelector(state => state.adviserAllList)
  const listsAllAdviser = dataadviserAllList.listsAllAdviser.map((item) => { return { value: item.id, label: item.name } });

  const dataadviserUpdate = useSelector(state => state.adviserUpdate)
  const { validation } = dataadviserUpdate

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const updated_by = userInfo.user.id

  useMemo(() => {
    if (adviser) {
      setname(adviser.name)
      setemail(adviser.email)
      setoffice(adviser.id_office)
      setphone(adviser.phone)
      setgender(adviser.gender)
      setjoindate(adviser.join_date)
      setstatus(adviser.active)
      setisnpwp(adviser.is_npwp)
      setissalary(adviser.is_salary)
      sethaired(adviser.haired_by)
      setNik(adviser.nik)
      setVerified(adviser?.is_verified)

      setNda(adviser.nda)
      setPfindo(adviser.pfindo)
      setKtp(adviser.ktp)
      setMcquaig(adviser.mcquaig)

      setAchievements(Array.isArray(adviser.achievements) ? adviser.achievements : [])
      setQualification([]);
      if (adviser.qualification?.length) {
        adviser.qualification?.forEach(element => {
          setQualification((prev) => {
            return [...prev, {
              title: element.title,
              imageUrl: process.env.REACT_APP_IMAGE_LINK + element.imageUrl
            }]
          })
        });
      }
    }
  }, [adviser])

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(adviserUpdate(name, email, office, phone, gender, joindate, status, isnpwp, issalary, haired, updated_by, id, history, nik, verified, ndaFile, pfindoFile, ktpFile, mcquaigFile, achievements, qualification))
  }

  const handleBlacklist = async (e) => {
    e.preventDefault();
    const res = await adviserBlacklist(id, blacklistReason);
    if (res.status === 200) {
      message.success('Berhasil Blacklist Adviser!')
      history.push('/adviser-index')
    } else {
      message.error('Gagal Blacklist Adviser!')
    }
  }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function base64ToBlob(base64, type) {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type });
  }

  const handleChangeNDA = (info) => {
    setNdaFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl => {
      setNda(imageUrl)
    }
      // setloading(false)
    );
  };

  const handleChangeMcquaig = (info) => {
    setMcquaigFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setMcquaig(imageUrl),
      // setloading(false)
    );
  };

  const handleChangePfindo = (info) => {
    setPfindoFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setPfindo(imageUrl),
      // setloading(false)
    );
  };

  const handleChangeKtp = (info) => {
    setKtpFile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setKtp(imageUrl),
      // setloading(false)
    );
  };

  const generateUrl = (x) => {
    if (x?.startsWith("data:image")) {
      return URL.createObjectURL(base64ToBlob(x, 'image/png'))
    }
    if (x?.startsWith("data:application/pdf")) {
      return URL.createObjectURL(base64ToBlob(x, 'application/pdf'))
    }
    return x
  }

  const beforeUpload = (file) => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(file.type)) {
      message.error('Only JPG, JPEG, PNG, and PDF files are allowed!');
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const addQualificationInput = () => {
    setQualification(prev => [...prev, { imageUrl: null, title: null }]); // default empty object
  };

  const updateQualification = (index, newData) => {
    setQualification(prev => {
      const updated = [...prev];
      updated[index] = newData;
      return updated;
    });
  };

  const removeQualificationInput = (indexToRemove) => {
    setQualification(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const addAchievementInput = () => {
    setAchievements(prev => [...prev, { rank: null, event: null, category: null }]); // default empty object
  };

  const removeAchievementInput = (indexToRemove) => {
    setAchievements(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const updateAchievement = (index, newData) => {
    setAchievements(prev => {
      const updated = [...prev];
      updated[index] = newData;
      return updated;
    });
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit Adviser</h3>
        </div>
      </div>
      <div className="clearfix"></div><br />
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>

            <div className="x_content">
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Name</label>
                      <input type="text"
                        className={validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control'}
                        required
                        onChange={(e) => setname(e.target.value)}
                        value={name}
                      />
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['name']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Email</label>
                      <input type="email"
                        className={validation.length !== 0 && validation['email'] ? 'form-control parsley-error' : 'form-control'}
                        required
                        onChange={(e) => setemail(e.target.value)}
                        value={email}
                      />
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['email']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                </div>
                <div>
                  <div className="form-group">
                    <label for="nik">NIK</label>
                    <input type="text"
                      className='form-control'
                      onChange={(e) => setNik(e.target.value)}
                      defaultValue={nik}
                      value={nik}
                    />
                  </div>
                </div>
                <div className="form-group d-flex flex-column">
                  <label for="name">Office</label>
                  <Select
                    showSearch
                    placeholder="Select an office"
                    optionFilterProp="children"
                    onChange={(value) => setoffice(value)}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={listsOffice}
                    value={office}
                  />
                  {
                    validation.length !== 0
                      ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['office']}</li>
                      </ul>
                      :
                      null
                  }
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Phone</label>
                      <input type="text"
                        className={validation.length !== 0 && validation['phone'] ? 'form-control parsley-error' : 'form-control'}
                        required
                        onChange={(e) => setphone(e.target.value)}
                        value={phone}
                      />
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['phone']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Gender</label>
                      <select
                        className={validation.length !== 0 && validation['gender'] ? 'form-control parsley-error' : 'form-control'}
                        required
                        onChange={(e) => setgender(e.target.value)}
                        defaultValue={gender}
                        value={gender}
                      >
                        <option disabled selected value="">Select Gender</option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                      </select>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['gender']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Join Date</label>
                      <input type="date"
                        className={validation.length !== 0 && validation['join_date'] ? 'form-control parsley-error' : 'form-control'}
                        name="name"
                        required
                        onChange={(e) => setjoindate(e.target.value)}
                        value={joindate}
                      />
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['join_date']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Status</label>
                      <select
                        className={validation.length !== 0 && validation['status'] ? 'form-control parsley-error' : 'form-control'}
                        required
                        onChange={(e) => setstatus(e.target.value)}
                        defaultValue={status}
                        value={status}
                      >
                        <option disabled selected value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                        <option value="3" hidden>Blacklist</option>
                      </select>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['status']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="form-group d-flex flex-column">
                  <label for="name">Haired By</label>
                  <Select
                    showSearch
                    placeholder="Hired by"
                    optionFilterProp="children"
                    onChange={(value) => sethaired(value)}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={listsAllAdviser}
                    value={haired}
                  />
                  {
                    validation.length !== 0
                      ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['haired']}</li>
                      </ul>
                      :
                      null
                  }
                </div>

                <div className="form-group d-flex flex-column">
                  <label>Training and Qualification</label>

                  <Collapse accordion style={{ border: "none" }}>
                    {qualification.map((value, index) => (
                      <Collapse.Panel
                        header={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{qualification[index].title || `Qualification ${index + 1}`}</span>
                            <button type='button' onClick={() => removeQualificationInput(index)} style={{ marginLeft: 'auto', color: 'darkblue', border: "none", borderRadius: "10px" }}><i class="fa fa-times"></i></button>
                          </div>
                        }
                        key={index}
                      >
                        <QualificationInput
                          uploadButton={uploadButton}
                          getBase64={getBase64}
                          generateUrl={generateUrl}
                          beforeUpload={beforeUpload}
                          onUpdate={(newValue) => updateQualification(index, newValue)}
                          value={value}
                        />
                      </Collapse.Panel>
                    ))
                    }
                  </Collapse>

                  <button
                    style={{ width: "20%", border: "none", alignSelf: "center", fontSize: "12px", marginTop: "10px" }}
                    type='button'
                    onClick={addQualificationInput}
                  >Add <PlusOutlined /></button>

                  {
                    validation.length !== 0
                      ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['qualification']}</li>
                      </ul>
                      :
                      null
                  }

                </div>

                <div className="form-group d-flex flex-column">
                  <label>Achievements</label>
                  <Collapse accordion style={{ border: "none" }}>
                    {achievements.map((value, index) => (
                      <Collapse.Panel
                        header={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{`Achievement ${index + 1}`}</span>
                            <button type='button' onClick={() => removeAchievementInput(index)} style={{ marginLeft: 'auto', color: 'darkblue', border: "none", borderRadius: "10px" }}><i class="fa fa-times"></i></button>
                          </div>
                        }
                        key={index}
                      >
                        <AchievementInput
                          onUpdate={(newValue) => updateAchievement(index, newValue)}
                          value={value}
                        />
                      </Collapse.Panel>
                    ))
                    }
                  </Collapse>

                  <button
                    style={{ width: "20%", border: "none", alignSelf: "center", fontSize: "12px", marginTop: "10px" }}
                    type='button'
                    onClick={addAchievementInput}
                  >Add <PlusOutlined />
                  </button>
                </div>

                <div className="row">
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <div className="form-group">
                      <label for="name">NPWP</label><br />
                      <Switch checked={(isnpwp === 1 ? true : false)} onChange={(e) => (e === true ? setisnpwp(1) : setisnpwp(0))} />
                      {/* {
                        isnpwp === 1 ?
                        :
                        <Switch onChange={(e) => (e === true ? setisnpwp(1) : setisnpwp(0))} />
                      } */}
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['npwp']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <div className="form-group">
                      <label for="name">Salary</label><br />
                      <Switch checked={(issalary === 1 ? true : false)} onChange={(e) => (e === true ? setissalary(1) : setissalary(0))} />
                      {/* {
                        issalary === 1 ?
                        :
                        <Switch compact onChange={(e) => (e === true ? setissalary(1) : setissalary(0))} />
                      } */}
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['salary']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <div className="form-group">
                      <label for="name">Verified</label><br />
                      <Switch checked={(verified === 1 ? true : false)} onChange={(e) => (e === true ? setVerified(1) : setVerified(0))} />
                      {/* {
                        issalary === 1 ?
                        :
                        <Switch compact onChange={(e) => (e === true ? setissalary(1) : setissalary(0))} />
                      } */}
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['verified']}</li>
                          </ul>
                          :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>NDA</label>
                    <Tooltip
                      title={nda ?
                        <a href={generateUrl(nda)} target="_blank">
                          <img src={nda?.startsWith("data:application/pdf") || nda?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : nda} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null}
                      placement="top"
                    >
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={handleChangeNDA}
                      >
                        {nda ?
                          <img src={nda?.startsWith("data:application/pdf") || nda?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : nda} alt="avatar" style={{ width: '90%' }} />
                          :
                          uploadButton
                        }
                      </Upload>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['nda']}</li>
                          </ul>
                          :
                          null
                      }
                    </Tooltip>
                  </div>

                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>Mcquaig Test</label>
                    <Tooltip
                      title={mcquaig ?
                        <a href={generateUrl(mcquaig)} target="_blank">
                          <img src={mcquaig?.startsWith("data:application/pdf") || mcquaig?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : mcquaig} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null}
                      placement="top"
                    >
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        onChange={handleChangeMcquaig}
                        beforeUpload={beforeUpload}
                      >
                        {mcquaig ? <img src={mcquaig?.startsWith("data:application/pdf") || mcquaig?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : mcquaig} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['mcquaig']}</li>
                          </ul>
                          :
                          null
                      }
                    </Tooltip>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>Pefindo Score</label>
                    <Tooltip
                      title={pfindo ?
                        <a href={generateUrl(pfindo)} target="_blank">
                          <img src={pfindo?.startsWith("data:application/pdf") || pfindo?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : pfindo} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null}
                      placement="top"
                    >
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        onChange={handleChangePfindo}
                        beforeUpload={beforeUpload}
                      >
                        {pfindo ? <img src={pfindo?.startsWith("data:application/pdf") || pfindo?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : pfindo} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['pfindo']}</li>
                          </ul>
                          :
                          null
                      }
                    </Tooltip>
                  </div>

                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <label>KTP</label>
                    <Tooltip
                      title={ktp ?
                        <a href={generateUrl(ktp)} target="_blank">
                          <img src={ktp?.startsWith("data:application/pdf") || ktp?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : ktp} alt="preview" style={{ width: 200 }} />
                        </a> :
                        null}
                      placement="top"
                    >
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        onChange={handleChangeKtp}
                        beforeUpload={beforeUpload}
                      >
                        {ktp ? <img src={ktp?.startsWith("data:application/pdf") || ktp?.includes('.pdf') ? "https://www.greenfoothills.org/wp-content/uploads/2017/11/PDF-icon-1.png" : ktp} alt="avatar" style={{ width: '90%' }} /> : uploadButton}
                      </Upload>
                      {
                        validation.length !== 0
                          ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['ktp']}</li>
                          </ul>
                          :
                          null
                      }
                    </Tooltip>
                  </div>
                </div>
                <div className='mt-4'>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModalBlacklist(true)}>Blacklist</button>
                  <button type="submit" className="btn btn-primary pull-right">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal open={showModalBlacklist} title={'Blacklist Adviser'} onCancel={() => setShowModalBlacklist(false)} footer={null}>
        <div className='flex flex-col mb-6 gap-4 items-center'>
          <h2 className='mx-auto text-center'>Perhatian!</h2>
          <p className='mx-auto text-center'>Anda yakin ingin blacklist Adviser?</p>
          <div className='text-center'>
            <p>Alasan :</p>
            <TextArea
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
              className='border'
              value={blacklistReason}
              onChange={e => setBlacklistReason(e.target.value)}
            />
          </div>
        </div>
        <hr className='mb-4' />
        <div className='d-flex flex-row-reverse gap-4'>
          <button type="button" className="btn btn-primary" onClick={() => setShowModalBlacklist(false)} >Cancel</button>
          <button type="submit" className="btn btn-secondary" onClick={handleBlacklist}>Blacklist</button>
        </div>
      </Modal>
    </div>
  )
}

export default AdviserEdit
